import { createInitialState, timePeriodReducer } from './reducer';
import timePeriodActions from './actions';
import useReducerWithActionCreators from '../../utils/useReducerWithActionCreators';

export default function useTimePeriodSelectorState(timePeriodOptions) {
	return useReducerWithActionCreators(timePeriodReducer, timePeriodOptions, createInitialState, timePeriodActions);
}
